import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import { Dialog } from './../../common/dialog';
import Input from './../../common/components/Input';
import Select from './../../common/components/Select';

class Form extends Component {
    static propTypes = {

    };

    renderInput(label, name, type, required, className = '') {
        const { formValues, formErrors, handleUpdateFormValue, formErrorMessages } = this.props;
        return (
            <div className={'input-container ' + className} key={name}>
                <div className="label-input"><label>{label} {required ? <span className="required">*</span> : null}</label></div>
                <div className="field-input">
                    <Input
                        name={name}
                        required={required}
                        formValues={formValues}
                        formErrors={formErrors}
                        formErrorMessages={formErrorMessages}
                        handleUpdateFormValue={handleUpdateFormValue.bind(this, type, required)}
                    />
                </div>
            </div>
        );
    }

    renderSelect(label, name, options, required, className = '') {
        const { formValues, formErrors, handleUpdateFormValue } = this.props;
        return (
            <div className={'input-container ' + className} key={name}>
                <div className="label-input"><label>{label} {required ? <span className="required">*</span> : null}</label></div>
                <div className="field-input">
                    <Select
                        name={name}
                        required={required}
                        options={options}
                        formValues={formValues}
                        formErrors={formErrors}
                        handleUpdateFormValue={handleUpdateFormValue.bind(this, 'text', required)}
                    />
                </div>
            </div>
        );
    }

    renderDepartments() {
        const { information, formValues, checkDepartment } = this.props;

        if (parseInt(formValues['type']) === 1 || parseInt(formValues['type']) === 2 || parseInt(formValues['type']) === 3) {
            return (
                <div className="employee-departments">
                    <div className="container-fluid">
                        <div className="row">
                            <h5 className="col">Departments</h5>
                        </div>
                        <div className="row">
                            {information.departments.map((department, index) => {
                                let checked = false;
                                if (formValues['departments_ids'].includes(department.id)) {
                                    checked = true;
                                }
                                return (
                                    <div key={'department-check-' + index} className="col-4">
                                        <input type="checkbox" onClick={(event) => checkDepartment(department.id, event.target.checked, index)} checked={checked} /> {department.name}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    render() {
        const { hideForm, handleSaveElement, isSavingForm, isFetchingElement } = this.props;

        let saveButtonLabel = 'Save';
        if (isSavingForm) {
            saveButtonLabel = <i className="fas fa-circle-notch fa-spin" />;
        }

        let form = (
            <form>
                <div className="subtitle">Employee Data</div>
                <div className="card mb-2">
                    <div className="card-header p-2">Employee Information</div>
                    <div className="card-body p-2 pt-0">
                        {this.renderInput('Code', 'code', 'text', true, 'third-field')}
                        {this.renderInput('Name', 'name', 'text', true, 'third-field')}
                        {this.renderInput('Email', 'email', 'text', false, 'third-field')}
                        {this.renderInput('Phone', 'phone', 'text', false, 'third-field')}
                        {this.renderInput('Department', 'department', 'text', true, 'third-field')}
                        {this.renderInput('Job Title', 'job_title', 'text', true, 'third-field')}
                        {this.renderSelect('Shift', 'shift', [
                            { label: 'Select option', value: '' },
                            { label: 'Day', value: 1 },
                            { label: 'Night', value: 2 }
                        ], true, 'third-field')}
                        {this.renderInput('Age', 'age', 'text', true, 'third-field')}
                        {this.renderSelect('Gender', 'gender', [
                            { label: 'Select option', value: '' },
                            { label: 'Male', value: 1 },
                            { label: 'Female', value: 2 }
                        ], true, 'third-field')}
                        {this.renderInput('Birth Date', 'birth_date', 'text', true, 'third-field')}
                        {this.renderInput('Hire Date', 'hire_date', 'text', true, 'third-field')}
                        {this.renderInput('Annual Pay', 'annual_pay', 'decimal', true, 'third-field')}
                        {this.renderSelect('Payment Type', 'payment_type', [
                            { label: 'Select option', value: '' },
                            { label: 'Salary', value: 1 },
                            { label: 'Hourly', value: 2 }
                        ], true, 'third-field')}
                        {this.renderSelect('Type', 'type', [
                            { label: 'Select option', value: '' },
                            { label: 'VP', value: 1 },
                            { label: 'Manager', value: 2 },
                            { label: 'Operator', value: 3 },
                        ], true, 'third-field')}
                        <div className="input-container third-field"></div>
                    </div>
                </div>
                <div className="row">
                    <div className="w-100"></div>
                    {this.renderDepartments()}
                </div>
            </form>
        );
        if (isFetchingElement) {
            form = <div className="loading-data"><i className="fas fa-circle-notch fa-spin" /> Loading data...</div>;
        }

        let actions = [
            <button key="save-button" className="btn btn-light btn-sm action-button" onClick={handleSaveElement} disabled={isSavingForm}>{saveButtonLabel}</button>,
            <button key="close-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideForm}>Close</button>
        ];
        return (
            <Dialog
                name="form"
                modal={false}
                actions={actions}
                contentStyle={{ width: 800 }}
                bodyStyle={{ overflow: 'initial' }}
            >
                <div className="form-container form-modal-container employees-form-container">{form}</div>
            </Dialog>
        );
    }
}

export default Form;
